import Loadable from 'react-loadable';
import ContentPaste from "material-ui-icons/ContentPaste";
import BookmarkBorder from "material-ui-icons/BookmarkBorder";
import VerifiedUser from "material-ui-icons/VerifiedUser";
import Notifications from "material-ui-icons/Notifications";
import Logout from "material-ui-icons/AccountBox";
import Equalizer from "material-ui-icons/Equalizer";
import Place from "material-ui-icons/Place";
import Loading from "../views/Places/Loading";

var dashRoutes = [
    {
        collapse: true,
        path    : "/analytics",
        name    : "Analytics",
        state   : "openAnalytics",
        icon    : Equalizer,
        pid      : 'analytics',
        views: [
            
            {
                path    : "/featured/:id/analytics",
                name    : "Featured",
                component: Loadable({
                    loader: () => import('../views/Dashboard/FeaturedAnalytics'),
                    loading: Loading,
                }),
                invisible: true,
                pid: 'analytics',
            },
            {
                path: "/analytics",
                name: "Analytics",
                component: Loadable({
                    loader: () => import('../views/Dashboard/Dashboard'),
                    loading: Loading,
                }),
                pid: 'analytics',
            },
        ],
        protected: true
    },
    {
        collapse: true,
        path: "/city",
        name: "City",
        state: "openCities",
        icon: Place,
        pid: 'cityRead',        
        protected: true,
        views: [
            {
                path: "/city/add",
                name: "Add City",
                component: Loadable({
                    loader: () => import('../views/City/AddCity'),
                    loading: Loading,
                }),
                pid: 'cityWrite',
                protected: true,
            },
            {
                path: "/city/:id/edit",
                name: "Edit City",
                component: Loadable({
                    loader: () => import('../views/City/EditCity'),
                    loading: Loading,
                }),
                invisible: true
            },
            {
                path: "/city",
                name: "Cities",
                component: Loadable({
                    loader: () => import('../views/City/CityList'),
                    loading: Loading,
                }),
                pid: 'cityRead',
                protected: true,
            },
        ]
    },
    {
        collapse: true,
        path: "/places",
        name: "Places",
        state: "openPlaces",
        icon: Place,
        pid: 'placeRead',        
        protected: true,
        views: [
            {
                path: "/places/add",
                name: "Add Place",
                component: Loadable({
                    loader: () => import('../views/Places/AddPlace'),
                    loading: Loading,
                }),
                pid: 'placeWrite',        
                protected: true,
            },
            {
                path: "/places/:id/edit",
                name: "Edit Place",
                component: Loadable({
                    loader: () => import('../views/Places/EditPlace'),
                    loading: Loading,
                }),
                invisible: true

            },
            {
                path: "/places/:id/analytics",
                name: "Analytics",
                component: Loadable({
                    loader: () => import('../views/Places/Analytics'),
                    loading: Loading,
                }),
                invisible: true
            },
            {
                path: "/places/:id/poi",
                name: "POIs",
                component: Loadable({
                    loader: () => import('views/POI/PoiPage'),
                    loading: Loading,
                }),
                invisible: true
            },
            {
                path: "/places",
                name: "Places",
                component: Loadable({
                    loader: () => import('../views/Places/PlacesPage'),
                    loading: Loading,
                }),
                pid: 'placeRead',        
                protected: true,
            }
        ]
    },
    {
        collapse: true,
        path: "/poi",
        name: "POI",
        state: "openPOI",
        icon: Place,
        pid: 'poiRead',        
        protected: true,
        views: [
            {
                path: "/poi/add",
                name: "Add POI",
                component: Loadable({
                    loader: () => import('views/POI/AddPOIPage'),
                    loading: Loading,
                }),
                pid: 'poiWrite',        
                protected: true,
            },
            {
                path: "/poi/:id/edit",
                name: "Edit POI",
                component: Loadable({
                    loader: () => import('views/POI/EditPOI'),
                    loading: Loading,
                }),
                invisible: true
            },
            {
                path: "/poi/:id/analytics",
                name: "Analytics",
                component: Loadable({
                    loader: () => import('views/POI/Analytics'),
                    loading: Loading,
                }),
                invisible: true
            },
            {
                path: "/poi",
                name: "POI",
                component: Loadable({
                    loader: () => import('views/POI/PoiPage'),
                    loading: Loading,
                }),
                pid: 'poiRead',        
                protected: true,
            },
        ]
    },
    {
        collapse: true,
        path    : "/categories",
        name    : "Categories",
        state   : "openCategories",
        icon    : BookmarkBorder,
        pid     : 'categoriesRead',
        protected: true,
        views   : [
            {
                path     : "/categories/add",
                name     : "Add Category",
                component: Loadable({
                    loader: () => import('../views/Categories/AddCategory'),
                    loading: Loading,
                }),
                protected: true,
                pid     : 'categoriesWrite',
                protected: true,
            },
            {
                path: "/categories/:id/edit",
                name: "Edit Category",
                component: Loadable({
                    loader: () => import('views/Categories/EditCategory'),
                    loading: Loading,
                }),
                invisible: true
            },
            {
                path     : "/categories",
                name     : "Categories",
                component: Loadable({
                    loader: () => import('../views/Categories/CategoriesList'),
                    loading: Loading,
                }),
                protected: true,
                pid     : 'categoriesRead',
                protected: true,
            }
        ]
    },
    {
        collapse: true,
        path    : "/files",
        name    : "Files",
        state   : "openFiles",
        icon    : ContentPaste,
        pid     : 'filesRead',
        protected: true,
        views   : [
            {
                path     : "/files/upload",
                name     : "Upload Files",
                component: Loadable({
                    loader: () => import('views/Files/UploadFilePage'),
                    loading: Loading,
                }),
                pid     : 'filesWrite',
                protected: true,
            },
            {
                path     : "/files",
                name     : "Files",
                component: Loadable({
                    loader: () => import('views/Files/FilesPage'),
                    loading: Loading,
                }),
                pid     : 'filesRead',
                protected: true,
            }
        ]
    },
    {
        collapse: true,
        path    : "/users",
        name    : "Users",
        state   : "openUsers",
        icon    : VerifiedUser,
        pid     : 'usersRead',
        protected: true,
        views   : [
            {
                path     : "/users/add",
                name     : "Add User",
                component: Loadable({
                    loader: () => import('../views/Users/AddUsersPage'),
                    loading: Loading,
                }),
                pid     : 'usersWrite',
                protected: true,
            },
            {
                path: "/users/:id/edit",
                name: "Edit User",
                component: Loadable({
                    loader: () => import('../views/Users/EditUsersPage'),
                    loading: Loading,
                }),
                pid     : 'usersWrite',
                invisible: true
            },
            {
                path     : "/users",
                name     : "Users",
                component: Loadable({
                    loader: () => import('../views/Users/UsersPage'),
                    loading: Loading,
                }),
                pid     : 'usersRead',
                protected: true,
            }
        ]
    },
    {
        path    : "/notifications",
        name    : "Notifications",
        state   : "openNotifications",
        icon    : Notifications,
        component: Loadable({
            loader: () => import('../views/Notifications/SendNotification'),
            loading: Loading,
        }),
        pid     : 'notifications',
        protected: true,
    },
    {
        path    : "/logout",
        name    : "Logout",
        state   : "logout",
        icon    : Logout,
        component: function() {
            localStorage.removeItem('authToken');
            window.location.reload();
        }
    },
    { 
        redirect: true,
        path: "/",
        pathTo: "/places",
        name: "Places"
    }
];
export default dashRoutes;



// WEBPACK FOOTER //
// ./src/routes/dashboard.jsx